import { useMutateEntry } from '@utils/component-framework';
import { arrangeZIndexes } from './utils/arrange-z-indexes.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useDeleteCloneEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const page = getPageEntryById(entry.data, args.pageId);
    page.clones = page.clones.filter(it => it.cloneId !== args.cloneId);
    arrangeZIndexes(page);
    return entry;
  });
}

export { useDeleteCloneEntryMutation };
//# sourceMappingURL=clone.delete.js.map
